/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/MaleBodyModel.glb 
Author: Diego Luján García (https://sketchfab.com/diegoluga)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/male-full-body-ecorche-ab11ebff89224f03bd75efede1164cf6
Title: Male Full Body Ecorche
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'
// import { useFrame } from '../../../public/MaleBodyModel.glb'

useGLTF.preload('/MaleBodyModel.glb')

export function MaleBodyModel(props) {
  const { nodes, materials } = useGLTF('/MaleBodyModel.glb')
  return (
    <group {...props} dispose={null}>
      <group
       rotation={[-Math.PI / 2, 0, 0]}
        position={[0, -5, 0]}
        scale={0.098} >
        <mesh geometry={nodes.Object_3.geometry} material={materials.defaultMat_12} />
        <mesh geometry={nodes.Object_5.geometry} material={materials.defaultMat_11} />
        <mesh geometry={nodes.Object_7.geometry} material={materials.defaultMat_10} />
        <mesh geometry={nodes.Object_9.geometry} material={materials.defaultMat_9} />
        <mesh geometry={nodes.Object_11.geometry} material={materials.material_1} />
        <mesh geometry={nodes.Object_13.geometry} material={materials.defaultMat_8} />
        <mesh geometry={nodes.Object_15.geometry} material={materials.defaultMat_7} />
        <mesh geometry={nodes.Object_17.geometry} material={materials.defaultMat_6} />
        <mesh geometry={nodes.Object_19.geometry} material={materials.defaultMat_5} />
        <mesh geometry={nodes.Object_21.geometry} material={materials.defaultMat_4} />
        <mesh geometry={nodes.Object_23.geometry} material={materials.defaultMat_3} />
        <mesh geometry={nodes.Object_25.geometry} material={materials.defaultMat_2} />
        <mesh geometry={nodes.Object_27.geometry} material={materials.defaultMat_1} />
        <mesh geometry={nodes.Object_29.geometry} material={materials.material_0} />
        <mesh geometry={nodes.Object_31.geometry} material={materials.defaultMat_0} />
        <mesh geometry={nodes.Object_33.geometry} material={materials.defaultMat} />
      </group>
    </group>
  )
}

useGLTF.preload('/MaleBodyModel.glb')
